import React from 'react';
import PropTypes from 'prop-types';

import { getMessage } from 'util/locale';

import ToolbarButton from './ToolbarButton.jsx';
import { ShapeType } from 'mapping/leaflet';

const DrawingToolbar = ({
  canUndoZoneHistory,
  onClickCreateStart,
  onClickMergeStart,
  onClickSplitStart,
  onClickUndo,
  isSaveTriggerLocked
}) => (
  <div className='vra-map-toolbar'>
    <ToolbarButton
      disabled={ isSaveTriggerLocked }
      onClick={ onClickMergeStart }
      testId="map-toolbar-merge-option"
      text={ getMessage('button-text__merge') } />

    <ToolbarButton
      disabled={ isSaveTriggerLocked }
      onClick={ onClickSplitStart }
      testId="map-toolbar-split-option"
      text={ getMessage('button-text__split') } />

    {isSaveTriggerLocked && (
      // Since the disabled property is not currently supported by the Dropdown, we don't
      // render the options to avoid UI inconsistencies. 
      // Also, ToolbarButton does not support the use of React.Fragment inside, so we must
      // avoid rendering the children to make it unusable.
      <ToolbarButton
        disabled={ isSaveTriggerLocked }
        testId="map-toolbar-draw-option"
        text={ getMessage('button-text__draw') } />
    )}

    {!isSaveTriggerLocked && (
      <ToolbarButton
        // We keep the disabled property to ensure this works properly when the behavior
        // is added in the future.
        disabled={ isSaveTriggerLocked }
        testId="map-toolbar-draw-option"
        text={ getMessage('button-text__draw') }>
        <ToolbarButton
          isChild={true}
          onClick={ () => onClickCreateStart(ShapeType.POLYGON) }
          testId='menu-option-polygon'
          text={ getMessage('button-text__draw-a-polygon') } />
        <ToolbarButton
          isChild={true}
          onClick={ () => onClickCreateStart(ShapeType.SQUARE) }
          testId='menu-option-square'
          text={ getMessage('button-text__draw-a-rectangle') } />
        <ToolbarButton
          isChild={true}
          onClick={ () => onClickCreateStart(ShapeType.CIRCLE) }
          testId='menu-option-circle'
          text={ getMessage('button-text__draw-a-circle') } />
      </ToolbarButton>
    )}
      
    <ToolbarButton
      disabled={ !canUndoZoneHistory || isSaveTriggerLocked}
      onClick={ onClickUndo }
      testId="map-toolbar-undo-option"
      text={ getMessage('button-text__undo') } />
  </div>
);

DrawingToolbar.propTypes = {
  canUndoZoneHistory:   PropTypes.bool.isRequired,
  isSaveTriggerLocked:  PropTypes.bool.isRequired,
  onClickCreateStart:   PropTypes.func.isRequired,
  onClickMergeStart:    PropTypes.func.isRequired,
  onClickSplitStart:    PropTypes.func.isRequired,
  onClickUndo:          PropTypes.func.isRequired
};

export default DrawingToolbar;
